<template>
  <div>
    <v-snackbar v-model="control" :timeout="timeout" :color="color" location="top">
      <div class="d-flex align-center">
        <v-icon
          color="white"
          class="mr-1"
          v-if="color !== 'error'"
          icon="mdi-check-circle-outline"
        ></v-icon>

        <v-icon
          color="white"
          class="mr-1"
          v-else
          icon="mdi-close-circle-outline"
        ></v-icon>

        <p>{{ text }}</p>
      </div>

      <template v-slot:actions>
        <v-btn color="white" icon="mdi-window-close" @click="control = false"></v-btn>
      </template>
    </v-snackbar>
    <!-- 參數 背景色、內容、執行時間 -->
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import snackbarStore from "code-library/store/snackbar.js";

const snackbar = snackbarStore();
// ----------------------------------------------------

// state
const { text, control, timeout, color } = storeToRefs(snackbar);
</script>
